import React, { PureComponent } from "react";
import {
  Card,
  CardBody,
  Col,
  Button,
  ButtonToolbar,
  Container,
  Row,
  Modal,
  Table,
} from "reactstrap";
import { Field, reduxForm } from "redux-form";
import 'react-accessible-accordion/dist/fancy-example.css';
import * as FileSaver from 'file-saver';
import EyeIcon from "mdi-react/EyeIcon";
import EmailIcon from "mdi-react/EmailIcon";
import AccountSearchIcon from "mdi-react/AccountSearchIcon";
//import Select from "react-dropdown-select";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import renderFileInputField from "../../../../shared/components/form/FileInput";
import renderSelectField from "../../../../shared/components/form/Select";
import renderMultiSelectField from "../../../../shared/components/form/MultiSelect";
import $ from "jquery";
import readXlsxFile from "read-excel-file";
//import Util from "../../../Common/util";
import XLSX from "xlsx";
import Sheet from "../../../../images/BIN_MASTER_v1.xlsx";
import { MDBDataTable } from "mdbreact";
//import API from "../../../Common/api";
import _ from "lodash";
import "./styles.css";
import LoadingOverlay from "react-loading-overlay";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import Alert from "reactstrap/lib/Alert";
import Util from '../../../Common/util';
import API from '../../../Common/api';
import {addAnalytics, paginationAnalytics} from '../../../Common/analytics';
import exportToCSV from '../../../Common/exportcsv';

//import styled, { css } from "styled-components";



var url = window.location.hostname;
var port = window.location.port;
var data_img = [];
var assign_arr= [];
var unassign_arr = [];
var data_type = "";
const Heading = [['ID', 'Order Id', 'Order Lines',  'Secondary Order Id', 'Status', 'Sub Group Id', 'Sub Group', 'Reassign',  'Total Order quantity', 'Total Scan Qty', 'Total Value',  'WH Plan Group Id', 'Light Priority', 'Max Light',  'Packing Station Type', 'Packing Station Master Id',  'Repetition Count', 'Station Id', 'Title',  'Warehouse Id', 'Zone', 'Name']];




class HorizontalForm extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  constructor() {
    super();
    this.getCookie = this.getCookie.bind(this);
  
    this.accessCookie = this.accessCookie.bind(this);
    this.toggle = this.toggle.bind(this);
    this.accessCookie = this.accessCookie.bind(this);
    this.SuccessConfirmtoggle = this.SuccessConfirmtoggle.bind(this);
    this.toggleOK = this.toggleOK.bind(this);
    this.toggle1 = this.toggle1.bind(this);
    this.toggle2 = this.toggle2.bind(this);


    this.state = {
      orderdata: [],
      variant_data: [],
      shelf_life_uom: [],
      ShowpopupLoader: false,
      showFilter: false,
      ShowConfirmLoader: false,
      stationType: [],
      stationStatus:[],
      unAssignOrder: [],
      assignOrder: [],
      isDisabledSearch: false,
      showConfirmError: false,
      group_id: "",
      selectedOutlet: "",
      selectedDistributor: "",
      selectedLocation: "",
      selectedOrder: "",
      order: [],
      row_data: [],
      arr_data: [],
      store: [],
      subStore:[],
      distributor:[],
      outlet:[],
      location: [],
      EditModal: false,
      hsn_value: "",
      loader1: false,
      showVariant: false,
      isDisabledApply: false,
      mc_code: false,
      hsn_code: [],
      applyPackSize: "",
      showTable: false,
      status_type: "1",
      apply: true,
      store_id: "",
      sub_store_id:"",
      task_id: "",
      polaris_id: "",
      task_type_value: "",
      request_id: "",
      showUnAssignedOrder: false,
      showFetchDispatchData: false,
      isChecked: false,
      disabledBtn: false,
      showData: false,
      showErrorMessage: false,
      apply1: true,
      total_value: "",
      total_quantity: "",
      modal: false,
      selectedGroup: "",
      selectedSubGroup:"",
      modal1: false,
      modal2: false,
      modalFailed: false,
      showAllItem: false,
      disabledReasonBtn: true,
      showInvalidItem: false,
      showProceedbtn: false,
      showReasonbtn: false,
      reasonCodeNeeded: false,
      SuccessConfirmmodal: false,
      modalReason: false,
      loadingconfirmbtn: false,
      loading: false,
      filtered_orderData : "",
      loading_overlay: false,
      url: window.location.hostname,
      port: window.location.port,
    };
  }

 
  toggleOK() {
    this.setState((prevState) => ({ modal: !prevState.modal }));
  }

  toggle() {
    this.setState((prevState) => ({ modal: !prevState.modal }));
  }
  toggle1() {
    this.setState((prevState) => ({ modal1: !prevState.modal1 }));
  }


  toggle2() {
    this.setState((prevState) => ({ modal2: !prevState.modal2 }));
  }

  toggleFailed() {
    this.setState((prevState) => ({ modalFailed: !prevState.modalFailed }));
  }


  SuccessConfirmtoggle() {
    this.setState((prevState) => ({
      SuccessConfirmmodal: !prevState.SuccessConfirmmodal,
    }));
  }

  componentWillMount() {
    if (window.location.port == 8091 || window.location.port === ":8090") {
      port = ":8090";
    }else if (window.location.port == 8098 || window.location.port === ":8098") {
      port = ":8099";
    } else {
      port = ":8088";
    }

    if (url === "localhost") {
      url = "15.206.34.41"+":8090";
    } else {
      url = window.location.hostname+port;
    }
    
    sessionStorage.setItem('PUstore_id', '')
    sessionStorage.setItem('PUpolaris_id', '')
    sessionStorage.setItem('PUstatus_type', '')
    sessionStorage.setItem('PUtask_type_value', '')
    sessionStorage.setItem('PUtask_id', '')

  /* sessionStorage.setItem('store_id', this.state.store_id)
    sessionStorage.setItem('polaris_id', this.state.polaris_id)
    sessionStorage.setItem('status_type', this.state.status_type)
    sessionStorage.setItem('task_type_value', this.state.task_type_value)
    sessionStorage.setItem('task_id', this.state.task_id)
*/

    var cookieUsername = this.getCookie("token");
    var Location = this.getCookie("selectedLocation");
    var username = this.accessCookie("token");
    this.setState(
      {
        userName: cookieUsername,
        selectedLocation: Location,
        store_id: sessionStorage.getItem('store_id') == "null" ? "" : sessionStorage.getItem('store_id') ,
        polaris_id: sessionStorage.getItem('polaris_id') == "null" ? "" : sessionStorage.getItem('polaris_id') ,
        task_id: sessionStorage.getItem('task_id') == "null" ? "" : sessionStorage.getItem('task_id') ,
        status_type: sessionStorage.getItem('status_type') == "null" || sessionStorage.getItem('status_type') == "" ? "1" : sessionStorage.getItem('status_type') ,
        task_type_value: sessionStorage.getItem('task_type_value') == "null" ? "" : sessionStorage.getItem('task_type_value')

      },
      () => {
        //this.fetchDispatch();
        // this.getSubGroupId();
      }
    );
  }

  

  accessCookie(cookieName) {
    var name = cookieName + "=";
    var allCookieArray = document.cookie.split(";");
    for (var i = 0; i < allCookieArray.length; i++) {
      var temp = allCookieArray[i].trim();
      if (temp.indexOf(name) == 0)
        return temp.substring(name.length, temp.length);
    }
    return "";
  }

  getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }





 


  handleChange1 = (e) => {
    this.setState({
      selectedGroup: e.target.value,
    });
  };

  changeSubGroup = (e) => {
    this.setState({
      selectedSubGroup: e.target.value,
    });
  };
 




  assembleDispatchData = (dispatchData) => {
    
    let DispatchData = dispatchData.map((post, index) => {
    
      return {
        id: post.id,
        order_id:post.order_id,
        order_lines:post.order_lines,
        secondary_order_id:post.secondary_order_id,
        status:post.status,
        sub_group_id:post.sub_group_id,
        subgroup_reassign:post.subgroup_reassign,
        total_order_qty:post.total_order_qty,
        total_scan_qty:post.total_scan_qty,
        total_value:post.total_value,
        wh_plan_group_id:post.wh_plan_group_id,
        light_priority:post.light_priority,
        max_light:post.max_light,
        packing_station_type:post.packing_station_type,
        packing_station_type_master_id:post.packing_station_type_master_id,
        repetition_count:post.repetition_count,
        station_id:post.station_id,
        title:post.title,
        warehouse_id:post.warehouse_id,
        zone:post.zone,
        name:post.name,
            
      };
    });

    this.setState({
      loading_overlay: false,
      loading: false,
      filtered_orderData : DispatchData,
    });

    return DispatchData;
  };


  downloadError = () => {
    //this.setState({loading:true})
    const payload = {
      location: this.state.selectedLocation,
      group_id: this.state.selectedGroup,
      station_type: this.state.selectedStation
  };

API.post('/product/product_master/v1/task/fetch/', { param: payload })
      .then((response) => response.data)
      .then((data) => {
        console.log("DataVal", data);
        this.setState({
          //showFetchDispatchData: true,
          loading: false
        });

        window.location.href= data.data[0]
      })
      .catch(function (error) {});
  };

  
  fetchDispatch = (order_no) => {
    this.setState({
      loading_overlay: true,
      loading: true,
    });

    var batch = localStorage.getItem('batch_id');

    const payload = {
      "report_type": 12,
  };
  addAnalytics('Report', 'View Packing Sation Order Report', payload);

API.post('/reports/multiReport/v1/', { param: payload })
      .then((response) => response.data)
      .then((data) => {
        this.setState({
          showFetchDispatchData: true,
        });

        
        if (data.length == 0) {
          this.toggle();
          this.setState({
            dispatch_status: true,
            showFetchDispatchData: false,
            loading_overlay: false,
            loading: false,
          });
          return false;
        }
        var arr_data = [];

        this.setState({
          orderData: data,
          // filtered_orderData : data,
          arr_data: arr_data,
          tableRowsMap: this.assembleDispatchData(data),
          showFetchDispatchData: true,
          dispatch_status: false,
        });
      })
      .catch(function(error) {});
  };


 filterData = (evt) => {
  if (evt == "") {
    this.setState({ filtered_orderData: this.state.orderData});
  } else {
    
    var value = this.state.orderData.filter(
      (val) =>{
      return Object.keys(val).some(key =>{
        var data = ""
        if (val[key] == null ) {
          data = ""
        } 
        else {
          data = val[key]
        }
        
        return data.toString().toLowerCase().includes(evt.toLowerCase()) 
      })
      }
      );
    
      this.setState({
        filtered_orderData: value,
      });
    }
  };

  render() {
    const { handleSubmit, reset, t } = this.props;
    const { showPassword } = this.state;
    const { modal, modal1, modal2 } = this.state;
    const { SuccessConfirmmodal, Failedmodal } = this.state;
  
    const dispatchData = {
      columns: [
      
        {
          label: "ID",

          field: "id",
          width: 120,
        },
        {
            label: "Order Id",
  
            field: "order_id",
            width: 120,
          },
          {
            label: "Order Lines",
  
            field: "order_lines",
            width: 120,
          },
          {
            label: "Secondary Order Id",
  
            field: "secondary_order_id",
            width: 120,
          },
          {
            label: "Status",
  
            field: "status",
            width: 120,
          },
          {
            label: "Sub Group Id",
  
            field: "sub_group_id",
            width: 120,
          },
          {
            label: "Sub Group Reassign",
  
            field: "sub_group_reassign",
            width: 120,
          },
          {
            label: "Total Order quantity",
  
            field: "total_order_qty",
            width: 120,
          },
          {
            label: "Total Scan Qty",
  
            field: "total_scan_qty",
            width: 120,
          },
          {
            label: "Total Value",
  
            field: "total_value",
            width: 120,
          },

          {
            label: "WH Plan Group Id",
  
            field: "wh_plan_group_id",
            width: 120,
          }, 
        {
          label: "Light Priority",

          field: "light_priority",
          width: 120,
        },

        {
          label: "Max Light",

          field: "max_light",
          width: 120,
        },

        {
          label: "Packing Station Type",

          field: "packing_station_type",
          width: 120,
        },
        {
          label: "Packing Station Master Id",

          field: "packing_station_type_master_id",
          width: 120,
        },
        {
          label: "Repetition Count",

          field: "repetition_count",
          width: 120,
        },
        {
          label: "Station Id",

          field: "station_id",
          width: 120,
        },
        {
          label: "Title",

          field: "title",
          width: 120,
        },
        {
          label: "Warehouse Id",

          field: "warehouse_id",
          width: 120,
        },
        {
          label: "Zone",

          field: "zone",
          width: 120,
        },
        {
          label: "Name",

          field: "name",
          width: 120,
        },
        

      ],

      rows: this.state.tableRowsMap,
    };

    return (
      <Col xl={16}>
        {this.state.loading_overlay && (
          <LoadingOverlay active={true}  />
        )}
        <Card>
          <CardBody style={{ width: 1584,
              paddingTop: 20,
              height: 80,
              paddingBottom: 0,  }}>
            <form className="form form--block" onSubmit={handleSubmit}>
            

              
              <div className="form__form-group col-xl-2">
              
                <ButtonToolbar className="form__button-toolbar">
                  <Button
                    className="btn-sm button_enable "
                    style={{
                      fontWeight: "normal",
                      textTransform: "capitalize",
                      borderRadius: 5,
                      backgroundColor: "#70bbfd",
                      color: "#fff",
                      padding: "5px 25px",
                      fontSize: "14px",
                    }}
                    id="button_enable"
                    onClick={() => this.fetchDispatch()}
                  >
                    {this.state.loading && (
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    )}
                    View Report
                  </Button>
                </ButtonToolbar>
              </div>
              <div style={{ width: "6%", marginBottom: "0px", float: "left" }}>
                <Button
                  type="button"
                  className="btn btn-primary-outline"
                  style={{
                    cursor: this.state.btnDisabled ? "pointer" : "pointer",
                    backgroundColor: this.state.btnDisabled
                      ? "#FFFFFF"
                      : "#FFFFFF",
                  }}
                  id="button_enable"
                
                >
                  
                  <img
                    src={require("../../../../images/download.png")}
                    onClick={(e) =>
                      exportToCSV(
                        this.state.filtered_orderData,
                        "Packing Station Order Report", Heading
                      )
                    }
                  />
                </Button>
              </div>
             
            </form>
         

          {this.state.showFetchDispatchData && (
            // <CardBody style={{ marginTop: 2, paddingTop: 0, paddingBottom: 0 }}>
              
             <div
                className="dispatchData stock_check_data style_table"
                style={{ marginTop: -27 }}
              >

                <MDBDataTable
                  scrollX
                  scrollY
                  maxHeight="390px"
                  displayEntries={false}
                  onPageChange = {(pageNumber) => paginationAnalytics(pageNumber.activePage,pageNumber.pagesAmount, 'Packing Sation Order', 'datatable_pagination_change' )}
                  striped
                  bordered
                  onSearch={this.filterData}
                  data={dispatchData}
                />
              </div>        
            // </CardBody>
          )}
           </CardBody>
        </Card>

      </Col>
    );
  }
}



export default reduxForm({
  form: "Upload Master", // a unique identifier for this form
})(withTranslation("common")(HorizontalForm));
